<template>
  <div class="preview-live-switch">
    <button
      :title="isPreview ? 'Remove Preview' : 'Show Preview'"
      :class="{'active': isPreview}"
      class="tb-btn-contained margin-left-xxs sample"
      data-entity="producer-togglePreview"
      :data-test="`producer-playlist-preview-${item.timeline_id}`"
      @click.stop="togglePreview"
    >
      <strong class="preview-icon">P</strong>
    </button>

    <button
      :title="isLive ? 'Remove Live' : 'Go Live'"
      :class="{'active': isLive}"
      class="tb-btn-contained margin-left-xxs alarm"
      data-entity="producer-toggleLive"
      :data-test="`producer-playlist-live-${item.timeline_id}`"
      @click.stop="toggleLive"
    >
      <strong class="live-icon">L</strong>
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState({
      production: (state) => state.production.production,
      preview: (state) => state.preview.production,
    }),

    timelineId() {
      return this.item.timeline_id;
    },

    isLive() {
      return this.production.index === this.timelineId;
    },

    isPreview() {
      return this.preview.index === this.timelineId;
    },
  },

  methods: {
    toggleLive() {
      this.$emit('live-clicked'); // emit to parent for conduit tracking posts taken live
      this.$store.dispatch('toggleLive', { timelineId: this.timelineId });
    },

    togglePreview() {
      this.$store.dispatch('togglePreview', { timelineId: this.timelineId });
    },
  },
};
</script>
